export const backendDateFormat = "YYYY-MM-DD HH:mm:ss.SSS";

export const MMM_D_YYYY = "MMM D, YYYY";
export const MMM_D_YYYY_HH_MM = "MMM D, YYYY hh:mm A";
export const YYYY_MM_DD = "YYYY-MM-DD";
export const MM_DD_YY = "MM/DD/YY";
export const MM_DD_YYYY_HH_MM = "MM/DD/YYYY hh:mm A";
